import Allocation from '../Allocation'
import Availability from '../Availability'
import { Contact } from '@/models'

export default class GetAvailabilityMutationPayload {
  availability: Availability
  contact: Contact
  allocations: Allocation[]

  constructor (availability: Availability, contact: Contact, allocations: Allocation[]) {
    this.availability = availability
    this.contact = contact
    this.allocations = allocations
  }
}
